module.exports = __webpack_public_path__ + "static/img/image9.e345302a.png";